import React, { useState,useRef} from "react";
import { useParams } from "react-router-dom";
import {
    Card,
    Box,
    useToast,
    Heading,
    Button,
    CardHeader,
    CardBody,
    useDisclosure,
    Drawer,
    DrawerContent,
    DrawerOverlay,
    DrawerCloseButton,
    DrawerHeader,
    DrawerBody,
    FormControl,
    FormLabel,
    Input,
    DrawerFooter,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
} from "@chakra-ui/react";
import axios from "axios";

import { Text } from "@chakra-ui/react";
import { Cell, LedgerRow, RowActions } from "../../../components/ui";
import { API_URL } from "../../../Apis/config";

function FamilyCard({ User, updateClick,deleteClick }) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const initialRef = useRef(null);
    const finalRef = useRef(null);
    const [formData, setFormData] = useState({});
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
    // const [totalAppointment, setTotalAppointment] = useState(0);
    // const [totalEvent, setTotalEvent] = useState(0);
    // const [totalAstro, setTotalAstro] = useState(0);
    const {id}=useParams()
    const toast = useToast();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
// console.log(name,value)
        if (name === "DOB") {
            // Reformat the date value to "dd/mm/yyyy"
            const [year, month, day] = value.split("-");
            const formattedDate = `${day}/${month}/${year}`;
            //   console.log(value)
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: formattedDate,
            }));
        } else {
            setFormData((prevFormData) => ({
                ...prevFormData,
                [name]: value,
            }));
        }
        // console.log(formData)
    };
    

    const onDeleteConfirm = () => {
        setIsDeleteAlertOpen(false);
        // Perform delete logic here
        axios
            .delete(`${API_URL}/users/${id}/family/${User._id}`)
            .then((res) => {
                // console.log(res);
                deleteClick(); 
                toast({
                    title: "Relation details Deleted",
                    description: "Relation details deleted successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                        
                // Perform any necessary actions after successful deletion
            })
            .catch((err) => {
                toast({
                    title: "Error",
                    description:
                        "An error occurred while submitting the form. Please try again later.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            });
    };

    return (
        <LedgerRow>
            <Cell label="Relation">{User.Relation}</Cell>
            <Cell label="Name"><Text fontWeight={600}>{User.Name}</Text></Cell>
            <Cell label="Nakshatram">{User.Nakshatram}</Cell>
            <Cell full>
                <RowActions>
                    <Button variant="outline" size="sm" onClick={onOpen}>Edit</Button>
                    <Button variant="danger" size="sm" onClick={() => setIsDeleteAlertOpen(true)}>Delete</Button>
                </RowActions>
            </Cell>

            

            <Drawer size="md"
                initialFocusRef={initialRef}
                finalFocusRef={finalRef}
                isOpen={isOpen}
                onClose={onClose}
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerHeader>Update Users Details</DrawerHeader>
                    <DrawerCloseButton />
                    <DrawerBody pb={6}>
                        <FormControl>
                            <FormLabel>Full Name</FormLabel>
                            <Input
                                type="text"
                                name="Name"
                                ref={initialRef}
                                onChange={handleInputChange}
                                
                                defaultValue={User.Name}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Relation</FormLabel>
                            <Input
                                type="text"
                                name="Relation"
                                onChange={handleInputChange}
                                defaultValue={User.Relation}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Nakshatram</FormLabel>
                            <Input
                                type="text"
                                name="Nakshatram"
                                onChange={handleInputChange}
                                defaultValue={User.Nakshatram}
                            />
                        </FormControl>
                    </DrawerBody>

                    <DrawerFooter>
                        <Button
                            mr={3}
                            onClick={() =>{ 
                                updateClick(formData, User._id)
                                onClose()}}
                        >
                            Save
                        </Button>
                        <Button variant="ghost" onClick={onClose}>Cancel</Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>

            <AlertDialog
                isOpen={isDeleteAlertOpen}
                leastDestructiveRef={finalRef}
                onClose={() => setIsDeleteAlertOpen(false)}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Delete Confirmation
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            Are you sure you want to delete this user?
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button variant="ghost"
                                ref={finalRef}
                                onClick={() => setIsDeleteAlertOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button variant="dangerSolid" onClick={onDeleteConfirm} ml={3}>
                                Delete
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </LedgerRow>
    );
}

export default FamilyCard;
